// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__Acc_f","footer":"ModalCreateQualiphyProcedure_footer__17ehs","additionData":"ModalCreateQualiphyProcedure_additionData__3KNah"};